import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {TokenService} from '../../../../core/auth';
import {Project} from '../../../../core/models';
import {BreadcrumbService} from '../../../../breadcrumb.service';
import {ProjectSidebarService} from '../../../../projectsidebar.service';
import {ProjectService, TelemetryService} from '../../../../core/services';
import * as moment from 'moment';
import {ConfigService} from '../../../../core/services/config.service';
import {SelectItem} from 'primeng/api';
import {Subject} from "rxjs";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {DataTable} from "primeng/datatable";
import {UIChart} from "primeng/chart";

const DAY = 24*60*60*1000;

@Component({
    selector: 'app-project-overview',
    templateUrl: './project-overview.page.html',
    styleUrls: ['./project-overview.scss']
})
export class ProjectOverviewPage implements OnInit {
    loading = false;
    id: string;
    project: Project;
    projectOrig: Project;
    authUser = this.token.whoAmI();

    eventType: any = 'Tampering detected';
    eventTypeOptions: SelectItem[];

    telemetryEventsByDayData: any;
    telemetryEventsByDayOptions: any;
    telemetryEventsByEventData: any;
    telemetryEventsByEventByDayData: any;
    telemetryEventsByEventByDayOptions: any;
    startDate: Date;
    endDate: Date;
    maxDate: Date;
    minDate: Date;
    searchValues: string[];

    constructor(
        private route: ActivatedRoute,
        private token: TokenService,
        private breadcrumbService: BreadcrumbService,
        private projectService: ProjectService,
        private telemetryService: TelemetryService,
        private projectSidebarService: ProjectSidebarService
    ) {
    }

    ngOnInit() {
        this.loading = true;

        this.setDates();

        this.telemetryService.getAllTelemetryEventTypes().subscribe(
            (data) => {
                this.eventTypeOptions = new Array();
                for (let i = 0; i < data.length; i++) {
                    this.eventTypeOptions.push({label: data[i], value: data[i]});
                }

            });

        this.route.parent.params.subscribe((params) => {
            this.id = params.id;
        });
        this.route.parent.data.subscribe(
            (data) => {
                if (data.project) {
                    this.project = Object.assign({}, data.project);

                    this.projectSidebarService.setProject(this.project);

                    this.breadcrumbService.setItems([
                        {label: 'projects', routerLink: ['/project', 'list']},
                        {label: this.project.name},
                        {label: 'details'},
                    ]);

                    this.getTelemetryEventsByDayStatistics();
                    this.getTelemetryEventsByEventStatistics();
                    this.getTelemetryEventsByEventByDayStatistics('Tampering detected');
                }
                this.loading = false;
            });
    }

    readProjectFromParent() {
        this.route.parent.data.subscribe(
            (data) => {
                this.project = Object.assign({}, data.project);
                this.projectOrig = Object.assign({}, data.project);
            }
        );
    }

    getTelemetryEventsByDayStatistics() {
        console.log(this.searchValues);
        this.projectService.getTelemetryEventsByDay(this.project.id, this.dateToString(this.startDate), this.dateToString(this.endDate), this.searchValues).subscribe(
            (response) => {

                const data = response.map(x => x.events);
                const labels = response.map(x => moment(x.day).format(ConfigService.dateFormat));

                this.telemetryEventsByDayData = {
                    labels: labels,
                    datasets: [
                        {
                            data: data,
                            fill: false,
                            borderColor: '#1976D2'
                        }
                    ]
                };

                // see https://www.chartjs.org/docs/latest/
                this.telemetryEventsByDayOptions = {
                    tooltips: {
                        enabled: false
                    },
                    elements: {
                        point: {
                            radius: 0
                        }
                    },
                    legend: {
                        display: false
                    },
                    title: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            display: true,
                            ticks: {
                                beginAtZero: true,
                            }
                        }]
                    }
                };
            }
        );
    }

    getTelemetryEventsByEventStatistics() {
        this.projectService.getTelemetryEventsByEvent(this.project.id, this.dateToString(this.startDate), this.dateToString(this.endDate), this.searchValues).subscribe(
            (response) => {

                const data = response.map(x => x.count);
                const labels = response.map(x => x.eventType);

                this.telemetryEventsByEventData = {
                    labels: labels,
                    datasets: [
                        {
                            data: data,
                            backgroundColor: [
                                '#d32f2f',
                                '#303F9F',
                                '#00796B',
                                '#FBC02D',
                                '#5D4037',
                                '#C2185B',
                                '#1976D2',
                                '#388E3C',
                                '#FFA000',
                                '#616161',
                                '#7B1FA2',
                                '#0288D1',
                                '#689F38',
                                '#F57C00',
                                '#455A64',
                                '#512DA8',
                                '#0097A7',
                                '#AFB42B',
                                '#E64A19',
                                '#ef9a9a',
                                '#9FA8DA',
                                '#80CBC4',
                                '#FFF59D',
                                '#BCAAA4',
                                '#F48FB1',
                                '#90CAF9',
                                '#A5D6A7',
                                '#FFE082',
                                '#EEEEEE',
                                '#CE93D8',
                                '#81D4FA',
                                '#C5E1A5',
                                '#FFCC80',
                                '#B0BEC5',
                                '#B39DDB',
                                '#80DEEA',
                                '#E6EE9C',
                                '#FFAB91'
                            ],
                            hoverBackgroundColor: [
                                '#d32f2f',
                                '#303F9F',
                                '#00796B',
                                '#FBC02D',
                                '#5D4037',
                                '#C2185B',
                                '#1976D2',
                                '#388E3C',
                                '#FFA000',
                                '#616161',
                                '#7B1FA2',
                                '#0288D1',
                                '#689F38',
                                '#F57C00',
                                '#455A64',
                                '#512DA8',
                                '#0097A7',
                                '#AFB42B',
                                '#E64A19',
                                '#ef9a9a',
                                '#9FA8DA',
                                '#80CBC4',
                                '#FFF59D',
                                '#BCAAA4',
                                '#F48FB1',
                                '#90CAF9',
                                '#A5D6A7',
                                '#FFE082',
                                '#EEEEEE',
                                '#CE93D8',
                                '#81D4FA',
                                '#C5E1A5',
                                '#FFCC80',
                                '#B0BEC5',
                                '#B39DDB',
                                '#80DEEA',
                                '#E6EE9C',
                                '#FFAB91'
                            ]
                        }]
                };

            }
        );
    }

    getTelemetryEventsByEventByDayStatistics(event: any) {
        this.telemetryEventsByEventByDayData = null;
        if (event.value) {
            event = event.value;
        }
        this.projectService.getTelemetryEventsByEventByDay(this.project.id, event, this.dateToString(this.startDate), this.dateToString(this.endDate), this.searchValues).subscribe(
            (response) => {

                const data = response.map(x => x.events);
                const labels = response.map(x => moment(x.day).format(ConfigService.dateFormat));

                this.telemetryEventsByEventByDayData = {
                    labels: labels,
                    datasets: [
                        {
                            data: data,
                            fill: false,
                            borderColor: '#d32f2f'
                        }
                    ]
                };

                // see https://www.chartjs.org/docs/latest/
                this.telemetryEventsByEventByDayOptions = {
                    tooltips: {
                        enabled: false
                    },
                    elements: {
                        point: {
                            radius: 0
                        }
                    },
                    legend: {
                        display: false
                    },
                    title: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            display: true,
                            ticks: {
                                beginAtZero: true,
                            }
                        }]
                    }
                };
            }
        );
    }

    dateToString(date: Date) : string {
        if (typeof date === 'undefined') {
            return null;
        } else {
            return  date.toLocaleDateString("fr-CA");
        }
    }

    setMinDate() {
        if (typeof this.startDate !== 'undefined') {
            this.minDate.setTime(this.startDate.getTime() + (DAY));
        }
    }

    setMaxDate()  {
        if (typeof this.endDate !== 'undefined') {
            this.maxDate.setTime(this.endDate.getTime() - (DAY));
        }
    }

    private setDates() {
        this.startDate = new Date();
        this.startDate.setTime(this.startDate.getTime() - (DAY * 6));
        this.minDate = new Date();
        this.minDate.setTime(this.minDate.getTime() - (DAY * 5));
        this.endDate = new Date();
        this.maxDate = new Date();
        this.maxDate.setTime(this.maxDate.getTime() - (DAY));
    }

}
